import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import styles from "./MasterCategoryDepartment.module.css";
import { Button, Form, Input, Popconfirm, Table, InputNumber, Modal, Select, Card, Divider, Layout, Space} from 'antd';
import { Content } from "antd/lib/layout/layout";
import { DeleteCategoryDepartment, GetCategoryDepartment, InsertCategoryDepartment } from "../../../Services/e-pro/CatalogMasterDataService";
import { IProductItem } from "../../../IRequestModel/ECatalog/IProductItemModel";
import { GetDepartment } from "../../../Services/DepartmentService";
import { SearchCatalogItem } from "../../../Services/e-pro/EcatalogService";
import { MapsDataToProductObject } from "../../../Helper/ECatalogHelper";
import { useUserContext } from "../../../Context/UserContext";
import Swal from "sweetalert2";

import { SearchOutlined } from '@ant-design/icons';
import type { InputRef } from 'antd';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps } from 'antd/es/table/interface';

import Highlighter from 'react-highlight-words';
import { GetDivision } from "../../../Services/DivisonService";
import { GetSection } from "../../../Services/SectionService";
import { GetPermissionByEmpId, GetRolePermission } from "../../../Services/RoleServices";
import { GetAllDynamic } from "../../../Services/DynamicService";

interface Values {
    DepartmentCode: string;
    DivisionCode?: string;
    SectionCode?: string;
    ProductItemID: any[];
    ActionUser: string;
}
interface CreateFormProps {
    open: boolean;
    onCreate: (values: Values) => void;
    onCancel: () => void;
    departmentDatasource: any;
    productDatasource: any;
    popupTitle: string;
    editValue?: Values
}
// const CreateForm: React.FC<CreateFormProps> = ({
//     open,
//     onCreate,
//     onCancel,
//     departmentDatasource,
//     productDatasource,
//     popupTitle,
//     editValue
// }) => {
//     //const [dates, setDates] = useState<RangeValue>([dayjs().startOf("year"), dayjs().endOf("year")]);
//     const [form] = Form.useForm();
//     interface IKeys { key1: string; key2: string }

//     let departmentOptions: { value: string; label: string }[] = [];

//     if (departmentDatasource != undefined) {
//         departmentOptions = departmentDatasource.map((item: any) => ({
//             value: item.DepartmentCode,
//             label: item.NameTh,
//         }));
//     }

//     let productOptions: { value: string; label: string }[] = [];

//     if (productDatasource != undefined) {
//         productOptions = productDatasource.map((item: any) => ({
//             value: item.itemId,
//             label: item.itemId,
//         }));
//     }



//     // const onSelect = (value: string) => {
//     //     console.log('onSelect', value);
//     // };
   
//     return (
        



//     );
// };
interface DataType {
    key: string;
    name: string;
    age: number;
    address: string;
  }
  
  type DataIndex = keyof DataType;

const MasterCategoryDepartment = () => {
    const [userData] = useUserContext();
    const [openPopupEdit, setOpenPopupEdit] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataDepartmentList, setDataDepartmentList] = useState<any>();
    const [dataDivisionList, setDataDivisionList] = useState<any>();
    const [dataSectionList, setDataSectionList] = useState<any>();
    
    const [dataProductList, setDataProductList] = useState<IProductItem[]>([]);
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [dataSourceDetail, setDataSourceDetail] = useState<Values>();
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [isDeptAdmin, setIsDeptAdmin] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [deptFilter, setDeptFilter] = useState([]);
    const [departmentSource, setDepartmentSource] = useState<any[]>([]);
    const [divisionSource, setDivisionSource] = useState<any[]>([]);
    const [sectionSource, setSectionSourcee] = useState<any[]>([]);

    const onPopupCreate = async (values: Values) => {
        setConfirmLoading(true);
        //console.log('Received values of form: ', values);
        let objectInsert =[];
        values.ProductItemID?.map(itemid => {
            objectInsert.push({
                DepartmentCode: values.DepartmentCode,
                DivisionCode:  values.DivisionCode === '' ? undefined : values.DivisionCode,
                SectionCode: values.SectionCode === '' ? undefined : values.SectionCode,
                ItemID: itemid,
                ActionUser: userData.EmployeeId.toString()
            });
        })
       
        await InsertCategoryDepartment(objectInsert);
        form.resetFields();
        setConfirmLoading(false);
        setOpenPopupEdit(false);
        setIsEditMode(false);
        // await addBackDateData(values, 1);
        fetchDataCategoryDepartment();
    };

    const onDeleteItemClick = async(value) => {
        let message = value.DepartmentName;
        if (value.DivisionName != null && value.DivisionName != '')
        {
            message = message + "," + value.DivisionName;
        }
        if (value.SectionName != null && value.SectionName != '')
        {
            message = message + "," + value.SectionName;
        }
        Swal.fire({
            title: "ยืนยันการลบรายการ" ,
            text: message, //value.DepartmentName,
            //icon: "question",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ไม่ยืนยัน",
            showCancelButton: true,
            confirmButtonColor: "#1890ff",
            cancelButtonColor: "#c95558",
        }).then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            await DeleteCategoryDepartment({ 
                DepartmentCode: value.DepartmentCode,
                DivisionCode: value.DivisionCode,
                SectionCode: value.SectionCode,
            });
            fetchDataCategoryDepartment();
            setLoading(false);
          }
        });
    }

    useEffect(() => {
        checkPermissionUser();
    }, []);

    useEffect(() => {
        fetchDataCategoryDepartment();
    }, [deptFilter]);

    useEffect(() => {
        processMasterData();
    }, [dataSource])

    const processMasterData = async () => {
        await fetchMasterDepartment();
        await fetchMasterDivision();
        await fetchMasterSection();
        await fetchMasterProduct();
        
        setDepartmentSource(bindingValueToDropdown("DEP"));
    };

    const checkPermissionUser = async () => {
        const dataPermission = await GetPermissionByEmpId({
            EmployeeId: userData.EmployeeId,
          });
      
          let isSuperAdmin: boolean = false;
          let isDeptAdmin: boolean = false;
          let canEdit: boolean = false;
          let deptFilterArray = [];
          //let permissions: any[] = await GetRolePermission();
          let roles: any[] = await GetAllDynamic("Roles/GetAll", undefined);
      
        if (dataPermission) {
            let listToCheck = dataPermission.map((perm) => {
              let getRole = roles.filter(x => x.RoleId === perm.roleId);
              return getRole[0];
            });
        
            console.log(listToCheck)
         
            var checkIsAdminRole = listToCheck.filter(x =>  x.RoleId === 1);
            if (checkIsAdminRole.length > 0) 
            {
                isSuperAdmin = true;
                setIsSuperAdmin(isSuperAdmin);
            }

            var deptAdmin = listToCheck.filter(x => x.NameTh.includes(" Admin "));
            if (deptAdmin.length > 0)
            {
                isDeptAdmin = true;
                deptFilterArray = deptAdmin.map( item => {
                    return item.NameTh.split(" Admin ")[0];
                })
                setIsDeptAdmin(isDeptAdmin);
                setDeptFilter(deptFilterArray);
            }
        }

    
      };

    const fetchDataCategoryDepartment = async() => {
        setLoading(true);

        let dept = await GetCategoryDepartment("");
        let categoryDeptData = dept.data;
        
        if (!isSuperAdmin && isDeptAdmin){
            //filter only current user is department admin

            //let test = filterObjectArray(categoryDeptData, deptFilterArray, "DepartmentCode");

            categoryDeptData = categoryDeptData.filter(obj => deptFilter.includes(obj["DepartmentCode"]));
        }
        setDataSource(categoryDeptData);
        setLoading(false);
    }

    function filterObjectArray<T, K extends keyof T>(
        objectArray: T[],
        filterArray: T[K][],
        key: K
      ): T[] {
        return objectArray.filter(obj => filterArray.includes(obj[key]));
      }

    const fetchMasterDepartment = async() => {
        let _data = await GetDepartment();

        if (!isSuperAdmin && isDeptAdmin){

            _data = _data.filter(obj => deptFilter?.includes(obj["DepartmentCode"]));
        }
        setDataDepartmentList(_data);

        
    }
    const fetchMasterDivision = async() => {
        let _data = await GetDivision();
        setDataDivisionList(_data);
    }
    const fetchMasterSection = async() => {
        let _data = await GetSection();
        setDataSectionList(_data);
    }

    const bindingValueToDropdown = (ddlType: string, filter?: string) => {
        let distinctSourceData = [];
        let ddlOption:  { value: string; label: string }[] = [];
        switch (ddlType) {
          case "DEP":
            if (dataDepartmentList !== undefined){
                distinctSourceData = dataDepartmentList
                //.filter((item: any) => item.funC_LEVEL == "EVP")
                .map((item: any) => ({
                      value: item.DepartmentCode,
                      label: item.NameTh,
                  }))
                .filter((name: any, index: any, currentVal: any) => currentVal.indexOf(name) === index)
                .sort((a: any, b: any) => (a.label > b.label ? 1 : -1));
            }
            break;
          case "DIV":
            distinctSourceData = dataDivisionList
              .filter((item: any) => item.DepartmentCode === form.getFieldValue("DepartmentCode"))
              .map((item: any) => ({
                    value: item.DivisionCode,
                    label: item.NameTh,
                }))
              .filter((name: any, index: any, currentVal: any) => currentVal.indexOf(name) === index)
              .sort((a: any, b: any) => (a.label > b.label ? 1 : -1));
            break;
          case "SEC":
            distinctSourceData = dataSectionList
              .filter((item: any) => item.DepartmentCode === form.getFieldValue("DepartmentCode") && item.DivisionCode === form.getFieldValue("DivisionCode"))
              .map((item: any) => ({
                    value: item.SectionCode,
                    label: item.SectionName,
                }))
              .filter((name: any, index: any, currentVal: any) => currentVal.indexOf(name) === index)
              .sort((a: any, b: any) => (a.label > b.label ? 1 : -1));
            break;
        }
        if (distinctSourceData.length > 0) ddlOption.push({ value: "", label: "" }); //set default values
        distinctSourceData.map((item: any) => {
          ddlOption.push(item);
        });
    
        //console.table(ddlOption);
        return ddlOption;
      };

    const [form] = Form.useForm();
    interface IKeys { key1: string; key2: string }

    let departmentOptions: { value: string; label: string }[] = [];

    if (dataDepartmentList != undefined) {
        departmentOptions = dataDepartmentList.map((item: any) => ({
            value: item.DepartmentCode,
            label: item.NameTh,
        }));
    }
    let divisionOptions: { value: string; label: string }[] = [];

    if (dataDivisionList != undefined) {
        divisionOptions = dataDivisionList.map((item: any) => ({
            value: item.DivisionCode,
            label: item.NameTh,
        }));
        divisionOptions = Array.from(
            new Map(divisionOptions.map(item => [item.value, item])).values()
          );
    }

    let sectionOptions: { value: string; label: string }[] = [];

    if (dataSectionList != undefined) {
        sectionOptions = dataSectionList.map((item: any) => ({
            value: item.SectionCode,
            label: item.SectionName,
        }));

        sectionOptions = Array.from(
            new Map(sectionOptions.map(item => [item.value, item])).values()
          );
    }
    let productOptions: { value: string; label: string }[] = [];

    if (dataProductList != undefined) {
        productOptions = dataProductList.map((item: any) => ({
            value: item.itemId,
            label: item.itemId + " : " + item.title,
        }));
    }


    const fetchMasterProduct = async() => {
        const dataJson = {
            searchItem : "",
            Catagoly :0,
            EmployeeId: 0
          };
        let response = await SearchCatalogItem(dataJson);
        const data = response.data;
       
        if (data === undefined) return;
        let productItem: IProductItem[] = MapsDataToProductObject(data);

        setDataProductList(productItem);
    } 

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
      ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
      };
      const getColumnSearchProps = (dataIndex: DataIndex, placeholder: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`ค้นหา ${placeholder}`}
                    value={`${selectedKeys[0] || ''}`}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) => {
            return record[dataIndex] != null && record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase())
        },
        //onFilterDropdownOpenChange: visible => {
        //    if (visible) {
        //        setTimeout(() => searchInput.current?.select(), 100);
        //    }
        //},
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const columns = [
        {
          title: 'หน่วยงาน',
          dataIndex: 'DepartmentName',
          key: 'DepartmentName',
          width: "20%",
          ...getColumnSearchProps('DepartmentName', 'หน่วยงาน')
        },
        {
            title: 'ฝ่าย',
            dataIndex: 'DivisionName',
            key: 'DivisionName',
            width: "20%",
            ...getColumnSearchProps('DivisionName', 'ฝ่าย')
          },
          {
            title: 'งาน',
            dataIndex: 'SectionName',
            key: 'SectionName',
            width: "20%",
            ...getColumnSearchProps('SectionName', 'งาน')
          },
        {
          title: 'สินค้าที่ต้องการแสดง',
          dataIndex: 'ItemIdString',
          key: 'ItemIdString',
          ...getColumnSearchProps('ItemIdString', 'สินค้าที่ต้องการแสดง')
        },
        {
            title: '#',
            key: 'action',
            width: "12%",
            render: (_, record) => (
                <Space>
                     <Button
                type="primary"
                onClick={() => {
                    let itemEdit:Values = {
                        DepartmentCode: record.DepartmentCode,
                        DivisionCode: record.DivisionCode,
                        SectionCode: record.SectionCode,
                        ProductItemID: record.ItemID,
                        ActionUser: userData.EmployeeId.toString()
                    }
                    //setDataSourceDetail(itemEdit);
                    form.setFieldsValue(itemEdit);
                    setOpenPopupEdit(true);
                    setDivisionSource(bindingValueToDropdown("DIV"));
                    setSectionSourcee(bindingValueToDropdown("SEC"));
                    setIsEditMode(true);
                }}
            >
                แก้ไขข้อมูล
            </Button>
            <Button
                type="primary"
                onClick={async () => {
                    await onDeleteItemClick(record);
                }}
            >
                ลบข้อมูล
            </Button>
                </Space>
               
            
            ),
          },
      ];
      
    return (
        <>
             <Layout>
        <Content className={styles.contents}>
          <div className={styles.content_header}>
            <p className={`${styles.p_tag} ${styles.header}`}>ข้อมูลสินค้าตามหน่วยงาน</p>
            <Button
                type="primary"
                onClick={() => {
                    setOpenPopupEdit(true);
                    setIsEditMode(false);
                }}
            >
                เพิ่มข้อมูล
            </Button>
            {/* <CreateForm
                open={openPopupEdit}
                onCreate={onPopupCreate}
                onCancel={() => {
                    onPopupCreate(false);
                    setDataSourceDetail(undefined);
                }}
                departmentDatasource={dataDepartmentList}
                productDatasource={dataProductList}
                popupTitle="จัดการสินค้าในแต่ละหน่วยงาน"
                editValue={dataSourceDetail}
            /> */}

            <Modal
            visible={openPopupEdit}
            className={styles.modal_detail}
            title="จัดการสินค้าในแต่ละหน่วยงาน"
            okText="บันทึก"
            cancelText="ยกเลิก"
            closable={false}
            maskClosable={false}
            loading={loading}
            confirmLoading={confirmLoading}
            width={1000}
            onCancel={() => {
                //onPopupCreate(false);
                let itemEdit:Values = {};
                //setDataSourceDetail(itemEdit);
                form.setFieldsValue(itemEdit);
                form.resetFields();

                setOpenPopupEdit(false);
                setIsEditMode(false);
            }}
            onOk={() => {
                form
                    .validateFields()
                    .then(values => {
                        onPopupCreate(values);
                      
                       
                    })
                    .catch(info => {
                        console.log('Validate Failed:', info);
                    });
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name="form_in_modal"
                initialValues={dataSourceDetail}
                preserve={false}
            >
                <Form.Item name="DepartmentCode" label="หน่วยงาน" rules={[{ required: true, message: 'เลือกหน่วยงาน' }]} >
                    <Select className="auto_control_backdate"
                        size="large"
                        showSearch
                        style={{ width: 200 }}
                        placeholder="เลือกหน่วยงาน"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={departmentSource}
                        onChange={(value, option) => { 
                            setDivisionSource(bindingValueToDropdown("DIV")); 
                            setSectionSourcee(bindingValueToDropdown("SEC"));
                            form.setFieldsValue({
                                DivisionCode: '',
                                SectionCode: ''
                            })
                        }}
                        disabled={isEditMode}

                    />
                </Form.Item>
                <Form.Item name="DivisionCode" label="ฝ่าย">
                    <Select className="auto_control_backdate" key={"division"}
                        size="large"
                        showSearch
                        style={{ width: 200 }}
                        placeholder="เลือกฝ่าย"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={divisionSource}
                        onChange={(value, option) => { setSectionSourcee(bindingValueToDropdown("SEC")); 
                            form.setFieldsValue({
                                SectionCode: ''
                            })
                        }}
                        disabled={isEditMode}
                    />
                </Form.Item>
                <Form.Item name="SectionCode" label="งาน">
                    <Select className="auto_control_backdate" key={"section"}
                        size="large"
                        showSearch
                        style={{ width: 200 }}
                        placeholder="เลือกงาน"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={sectionSource}
                        disabled={isEditMode}
                    />
                </Form.Item>
                <Form.Item name="ProductItemID" label="สินค้าที่แสดง" rules={[{ required: true, message: 'เลือกสินค้าที่แสดง' }]}>
                    <Select className="auto_control_backdate"
                        size="middle"
                        showSearch
                        mode="multiple"
                        style={{ width: 200 }}
                        placeholder="เลือกสินค้าที่แสดง"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        options={productOptions}
                    />
                </Form.Item>
            </Form>
        </Modal>

          </div>
          <Table rowKey={record => record.id}
                    
                    //rowClassName={(record, rowIndex) => { return rechekTotalAtRow(record.salaryNetBalance) }}
                    className={'main-table-salary'}
                    bordered
                    dataSource={dataSource}
                    columns={columns} /*scroll={{ x: 4000, y: 700 }}*/ loading={loading}
                    pagination={{ position: ['bottomCenter'] }}
                    // expandable={{
                    //     //rowExpandable: true,
                    //     expandedRowRender : (record) => {
                    //         //const nestedTable = [nestedTable0, nestedTable1, nestedTable2];
                    //         return expandedRowRender(record, "1");
                    //     }
                    // }}
                    

                />
        </Content>
      </Layout>

          
        </>
    );
}
export default MasterCategoryDepartment;
